import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { isObject } from '@/utils'
import { getUserLocalData } from '@/utils/auth'
import Cookies from 'js-cookie'

const service = axios.create({
  baseURL: '/',
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

service.interceptors.request.use(config => {
  // console.log(config)
  if(!config.multi){
    config.data = qs.stringify(config.data)
  }
  if(getUserLocalData().lms_token && !config.baseURL.includes('apipool') && !config.url.includes('school/getChannelInfo')){
    config.headers.Token = getUserLocalData().lms_token
  }


  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {

    if(!isObject(response.data)) {
      return Promise.reject(response.data)
    }

    if(response.data.code <= 0) {
      // 登录态失效，跳转sso去登录
      if(response.data.code >= -5999999 && response.data.code <= -5990000) {
        window.location.href = response.data.data.redirectUrl
      }
      return Promise.reject(response.data)
    }

    return response.data
  },
  error => {
    window.$Raven && window.$Raven.captureException(error)
    console.log('err' + error)// for debug
    if (typeof error.msg != 'undefined'){
      Message({
        message: error.msg || '网络延迟，请刷新！',
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js